import React, { useState } from "react";

const DISCORD_WEBHOOK_URL =
  "https://discord.com/api/webhooks/1375118631826100235/r6-IL5SoWCWJnd3YP6cWINhqRqxzfk1WorNHW8yPaB0MTxgD99LGU_hPGG7BkvmFJ4V0";

const CustomRankRequest = () => {
  const [formData, setFormData] = useState({
    minecraftName: "",
    discordTag: "",
    desiredRank: "",
    reason: "",
  });

  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const embed = {
      title: "🌟 New Custom Rank Request",
      color: 0xf1c40f,
      fields: [
        {
          name: "Minecraft Username",
          value: formData.minecraftName || "N/A",
        },
        {
          name: "Discord Tag",
          value: formData.discordTag || "N/A",
        },
        {
          name: "Desired Rank/Title",
          value: formData.desiredRank || "N/A",
        },
        {
          name: "Reason",
          value: formData.reason || "N/A",
        },
      ],
      timestamp: new Date().toISOString(),
    };

    try {
      const res = await fetch(DISCORD_WEBHOOK_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ embeds: [embed] }),
      });

      if (res.ok) {
        setSuccessMsg("✅ Custom rank request submitted successfully!");
        setErrorMsg("");
        setFormData({
          minecraftName: "",
          discordTag: "",
          desiredRank: "",
          reason: "",
        });
      } else {
        setErrorMsg("❌ Submission failed. Please try again.");
        setSuccessMsg("");
      }
    } catch (err) {
      setErrorMsg("❌ Network error. Please try again later.");
      setSuccessMsg("");
    }
  };

  return (
    <div className="container" style={{ maxWidth: 500, margin: "2rem auto" }}>
      <h2>Custom Rank Request</h2>
      <p>Request a custom rank or title on the server.</p>

      <form onSubmit={handleSubmit}>
        <label htmlFor="minecraftName">Minecraft Username:</label>
        <input
          type="text"
          id="minecraftName"
          value={formData.minecraftName}
          onChange={handleChange}
          placeholder="Your Minecraft username"
          required
        />

        <label htmlFor="discordTag">Discord Tag (e.g. user#1234):</label>
        <input
          type="text"
          id="discordTag"
          value={formData.discordTag}
          onChange={handleChange}
          placeholder="Your Discord Tag"
          required
        />

        <label htmlFor="desiredRank">Desired Rank/Title:</label>
        <input
          type="text"
          id="desiredRank"
          value={formData.desiredRank}
          onChange={handleChange}
          placeholder="What custom rank or title do you want?"
          required
        />

        <label htmlFor="reason">Reason for Request:</label>
        <textarea
          id="reason"
          rows="4"
          value={formData.reason}
          onChange={handleChange}
          placeholder="Why do you want this custom rank?"
          required
        ></textarea>

        <button type="submit" style={{ marginTop: "1rem" }}>
          Submit Request
        </button>

        {successMsg && (
          <div style={{ marginTop: "1rem", color: "green" }}>{successMsg}</div>
        )}
        {errorMsg && (
          <div style={{ marginTop: "1rem", color: "red" }}>{errorMsg}</div>
        )}
      </form>
    </div>
  );
};

export default CustomRankRequest;
